/* ── SmartPack Core — Blanket / subscription cart bridge ── */
(function () {
  'use strict';

  var DEBUG = false;
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[sp-blanket]'].concat([].slice.call(arguments))); }

  var nativeFetch = window.fetch.bind(window);

  var STORAGE_KEY = 'sp_pending_blanket';
  var MAX_AGE_MS = 30 * 60 * 1000;

  var PLANS = {
    '703437373753': { key: '2wk', perYear: 26, label: 'Ships every 2 Weeks' },
    '703437340985': { key: 'mon', perYear: 12, label: 'Ships every Month' },
    '703437406521': { key: '2mo', perYear: 6,  label: 'Ships every 2 Months' },
    '703437439289': { key: 'qtr', perYear: 4,  label: 'Ships Every 3 Months' },
    '703437472057': { key: '6mo', perYear: 2,  label: 'Ships every 6 Months' }
  };

  var BAND_MINS = [1000, 2500, 5000, 10000, 25000, 50000, 75000, 100000, 200000, 400000];

  var BANDS = BAND_MINS.map(function (m) { return { min: m }; });

  var SUB_QTY_STEP = 500;
  var SUB_QTY_MIN = 500;

  function spBandValue(qtyPerShipment, planId, data) {
    var plan = PLANS[String(planId)];
    if (!plan) return null;
    var qty = parseInt(qtyPerShipment, 10);
    if (!qty || qty < 1) return null;
    var annual = qty * plan.perYear;

    if (data && data.arCap && annual > data.arCap) return null;

    var mins = (data && data.blanketBands && data.blanketBands.length)
      ? data.blanketBands.map(function (b) { return b.min; })
          .filter(function (m) { return BAND_MINS.indexOf(m) !== -1; })
      : BAND_MINS;

    var band = null;
    for (var i = 0; i < mins.length; i++) {
      if (annual >= mins[i]) band = mins[i];
    }
    if (!band) return null;
    return band + '|' + plan.key;
  }

  var _pageData;
  function pageBandData() {
    if (_pageData !== undefined) return _pageData;
    _pageData = null;
    var el = document.querySelector('[data-sp-band-data]');
    if (el) {
      try { _pageData = JSON.parse(el.textContent); } catch (e) { _pageData = null; }
    }
    return _pageData;
  }

  window.SPBlanket = { spBandValue: spBandValue, PLANS: PLANS, BANDS: BANDS,
    BAND_MINS: BAND_MINS, pageBandData: pageBandData };

  /* ── 2. Reading the page ── */

  function qtyInput() {
    return document.querySelector('[data-sp-qty-raw], [data-sp-quantity-input], input[name="quantity"]');
  }

  function currentQty() {
    var el = qtyInput();
    if (!el) return 1;
    return parseInt(String(el.value).replace(/[^0-9]/g, ''), 10) || 1;
  }

  function selectedPlanId() {
    var checked = document.querySelector('input[name="selling_plan"]:checked');
    if (!checked) return '';
    var val = (checked.value || '').trim();
    if (!val) return '';
    var sel = document.querySelector('select[name="selling_plan"], .appstle_subscription_wrapper select, #appstle_subscription_dropdown');
    if (sel && sel.value && PLANS[sel.value]) return sel.value;
    return PLANS[val] ? val : '';
  }

  function productForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function variantId() {
    var form = productForm();
    var idEl = form && form.querySelector('[name="id"]');
    if (idEl && idEl.value) return String(idEl.value);
    var priceEl = document.querySelector('[data-sp-variant-id]');
    return priceEl ? String(priceEl.getAttribute('data-sp-variant-id')) : '';
  }

  function ensureHidden(form, name) {
    var el = form.querySelector('input[type="hidden"][name="' + name + '"][data-sp-blanket]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-sp-blanket', '');
      form.appendChild(el);
    }
    return el;
  }

  function dropHidden(form, name) {
    var el = form.querySelector('input[type="hidden"][name="' + name + '"][data-sp-blanket]');
    if (el) el.parentNode.removeChild(el);
  }

  function syncForm() {
    var form = productForm();
    if (!form) return;
    var planId = selectedPlanId();

    if (!planId) {
      dropHidden(form, 'selling_plan');
      dropHidden(form, 'properties[_sp_band]');
      log('one-time — form cleared');
      return;
    }

    ensureHidden(form, 'selling_plan').value = planId;

    var band = spBandValue(currentQty(), planId, pageBandData());
    if (band) {
      ensureHidden(form, 'properties[_sp_band]').value = band;
      log('subscription', planId, 'qty', currentQty(), '→', band);
    } else {
      dropHidden(form, 'properties[_sp_band]');
      document.dispatchEvent(new CustomEvent('sp:band-unavailable', {
        detail: { qty: currentQty(), planId: planId }
      }));
      log('subscription', planId, 'qty', currentQty(), '→ NO BAND');
    }
  }

  /* ── 4. Subscription quantity rules ── */
  var savedRules = null;

  function applyQtyRules() {
    if (document.querySelector('[data-sp-buy]')) {
      document.dispatchEvent(new CustomEvent('sp:quantity-rules-changed'));
      return;
    }

    var el = qtyInput();
    if (!el) return;
    var isSub = !!selectedPlanId();

    if (isSub) {
      if (!savedRules) savedRules = { min: el.min, step: el.step };
      el.min = String(SUB_QTY_MIN);
      el.step = String(SUB_QTY_STEP);
      var v = parseInt(el.value, 10) || 0;
      var snapped = Math.max(SUB_QTY_MIN, Math.ceil(v / SUB_QTY_STEP) * SUB_QTY_STEP);
      if (snapped !== v) {
        el.value = String(snapped);
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (savedRules) {
      el.min = savedRules.min;
      el.step = savedRules.step;
      savedRules = null;
    }
    document.dispatchEvent(new CustomEvent('sp:quantity-rules-changed'));
  }

  /* keys already in the cart before the customizer opens, so the patch never lands on an old line */
  var seenKeys = [];

  function snapshotCart() {
    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { seenKeys = cart.items.map(function (it) { return it.key; }); })
      .catch(function () {});
  }

  function stash() {
    var planId = selectedPlanId();
    var qty = currentQty();
    var vid = variantId();
    if (!vid) return;
    var payload = {
      handle: productHandle(),
      variantId: vid,
      quantity: qty,
      sellingPlanId: planId || '',
      spBand: planId ? (spBandValue(qty, planId, pageBandData()) || '') : '',
      seen: seenKeys.slice(),
      ts: Date.now()
    };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload)); } catch (e) {}
    log('stashed', payload);
  }

  function readStash() {
    var raw;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    if (!raw) return null;
    var data;
    try { data = JSON.parse(raw); } catch (e) { clearStash(); return null; }
    if (!data || !data.ts || (Date.now() - data.ts) > MAX_AGE_MS) { clearStash(); return null; }
    return data;
  }

  function clearStash() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* the cart template masks itself on sight of a stash; nothing else lifts it */
  function unmask() {
    try {
      document.documentElement.classList.remove('sp-cart-pending');
      var st = document.getElementById('sp-cart-pending-style');
      if (st && st.parentNode) st.parentNode.removeChild(st);
    } catch (e) {}
  }

  function productHandle() {
    var sec = document.querySelector('[data-product-handle]');
    if (sec) return sec.getAttribute('data-product-handle');
    var m = path().match(/^\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function path() {
    return window.location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
  }

  function enforceScope() {
    var data = readStash();
    if (!data) return;
    var p = path();
    var ok =
      (data.handle && p === '/products/' + data.handle) ||
      p.indexOf('/apps/qstomizer') === 0 ||
      p === '/cart' || p.indexOf('/cart/') === 0 ||
      p.indexOf('/checkout') === 0;
    if (!ok) { log('scope kill at', p); clearStash(); }
  }

  /* ── The patch ── */

  function patchCart() {
    var data = readStash();
    if (!data) return;
    if (!data.sellingPlanId && data.quantity === 1) { clearStash(); unmask(); return; }

    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Shopify prepends new lines: walk newest-first */
        var seen = data.seen || [];
        var it = null, line = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var cand = cart.items[i];
          if (seen.indexOf(cand.key) !== -1) continue;
          if (String(cand.variant_id) !== String(data.variantId)) continue;
          if (cand.selling_plan_allocation) continue;
          var props = cand.properties || {};
          var isCustom = Object.keys(props).some(function (k) { return k.indexOf('_custom') === 0; });
          if (!isCustom) continue; // Qstomizer prefix match
          it = cand; line = i + 1;
          break;
        }
        if (!it) { log('no matching line'); clearStash(); unmask(); return; }

        var body = { id: it.key, quantity: data.quantity };
        if (data.sellingPlanId) body.selling_plan = data.sellingPlanId;

        if (data.spBand) {
          var merged = {};
          var existing = it.properties || {};
          Object.keys(existing).forEach(function (k) { merged[k] = existing[k]; });
          merged._sp_band = data.spBand;
          body.properties = merged;
        }

        clearStash();

        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (updated) {
            var patched = updated.items[line - 1];
            if (patched && patched.quantity !== data.quantity) {
              document.dispatchEvent(new CustomEvent('sp:quantity-capped', {
                detail: { requested: data.quantity, applied: patched.quantity, line: line }
              }));
            }
            document.dispatchEvent(new CustomEvent('sp:cart-patched', { detail: { line: line, data: data } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            log('patched line', line, body);

            if (onCartPage()) window.location.reload();
          });
      })
      .catch(function (e) { log('patch failed', e); clearStash(); unmask(); });
  }

  /* ── 6. Wiring ── */

  function onProductPage() { return path().indexOf('/products/') === 0; }
  function onCartPage() { return path() === '/cart' || path().indexOf('/cart/') === 0; }
  function onProxyPage() { return path().indexOf('/apps/qstomizer') === 0; }

  function hydrateFromProxyUrl() {
    if (readStash()) return;
    var p = new URLSearchParams(window.location.search);
    var vid = p.get('variantid') || p.get('variantId');
    var qty = parseInt(p.get('quantity'), 10);
    if (!vid || !qty || qty < 2) return;
    var payload = {
      handle: '', variantId: String(vid), quantity: qty,
      sellingPlanId: '', spBand: '', ts: Date.now()
    };
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload)); } catch (e) {}
    log('hydrated from proxy url', payload);
  }

  function initProduct() {
    if (!productForm() && !document.querySelector('[data-sp-product]')) return;

    var QTY_SEL = '[data-sp-qty-raw], [data-sp-quantity-input], input[name="quantity"]';

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('input[name="selling_plan"], select[name="selling_plan"], .appstle_subscription_wrapper select, #appstle_subscription_dropdown')) {
        applyQtyRules();
        syncForm();
      } else if (e.target.matches(QTY_SEL)) {
        syncForm();
      }
    });
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches(QTY_SEL)) syncForm();
    });
    document.addEventListener('sp:quantity-rules-changed', syncForm);

    var tries = 0;
    var poll = setInterval(function () {
      syncForm();
      if (++tries > 40 || document.querySelector('input[name="selling_plan"]')) {
        if (document.querySelector('input[name="selling_plan"]')) { applyQtyRules(); syncForm(); }
        clearInterval(poll);
      }
    }, 250);

    window.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('#qstomizer-product-button, #qstomizer-button-block-container a, #qstomizer-button-block-container button, [href*="/apps/qstomizer"]');
      if (!t) return;
      stash();

      var form = productForm();
      if (form) dropHidden(form, 'properties[_sp_band]');

      try {
        if (t.href) {
          var u = new URL(t.href, window.location.origin);
          u.searchParams.delete('properties[_sp_band]');
          t.href = u.toString();
        }
      } catch (err) {}
    }, true);

    snapshotCart();
    syncForm();
  }

  function boot() {
    enforceScope();
    if (onProxyPage()) hydrateFromProxyUrl();
    if (onProductPage()) initProduct();
    if (onCartPage()) patchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    enforceScope();
    if (onProductPage()) snapshotCart();
    if (onCartPage()) patchCart();
  });
})();
